export const EMPTY_FORM_DATA = {
  name: '',
  description: '',
  startTime: new Date(),
  endTime: new Date(),
  timezone: '',
  virtualEventUrl: null,
  dressCode: '',
  location: null,
  placeId: null,
  showMap: false,
  tags: [],
};
